<template>
  <el-row style="margin-top: -10px" >
    <el-col>
      <el-row style="margin-bottom: 10px">
        <el-card class="box-card" style="width: 800px;margin-left: -20px">
<!--          <el-button-group >-->
<!--            <el-button type="primary" icon="el-icon-refresh" round size="medium" @click="refreshData(0)">未导出 </el-button>-->
<!--            <el-button type="primary" icon="el-icon-refresh" round size="medium" @click="refreshData(1)">已导出 </el-button>-->
<!--            <el-button type="info" icon="el-icon-picture-outline-round"  size="medium" @click="queryData">数据用量</el-button>-->
<!--            <el-button type="success" icon="el-icon-circle-plus"  size="medium" @click="DialogVisible = true">添加数据</el-button>-->
<!--          </el-button-group>-->
<!--          <el-button-group >-->
<!--            <el-button type="success" icon="el-icon-circle-plus" round size="medium" @click="exPort">导出文件</el-button>-->
<!--            <el-button type="danger" icon="el-icon-delete-solid" round size="medium" @click="clearData">清空数据</el-button>-->
<!--          </el-button-group>-->


<!--          <el-button type="success" icon="el-icon-s-flag" round size="medium" @click="getDataOne">获取</el-button>-->
<!--          <el-button type="primary" icon="el-icon-refresh" round size="medium" @click="refreshData">刷新</el-button>-->

          <el-input
              placeholder="搜索的数据"
              v-model="pagParams.searchval"
              clearable
              style="height: 30px; width: 200px;margin-left: 10px;margin-right: 10px"
              prefix-icon="el-icon-view">
          </el-input>
          <el-button type="primary" icon="el-icon-search" round size="medium" @click="searchData">搜索</el-button>

        </el-card>
      </el-row>
<!--      <el-popover-->
<!--          placement="right"-->
<!--          width="80%"-->
<!--          trigger="manual"-->
<!--          v-model="visibleLab">-->
<!--        <el-table :data="labData" :row-class-name="tableRowClassName" v-loading="loadingLab" border>-->
<!--          <el-table-column width="100" property="total" label="总数"></el-table-column>-->
<!--          <el-table-column width="100" property="status_u" label="已使用"></el-table-column>-->
<!--          <el-table-column width="100" property="status_0" label="未使用"></el-table-column>-->
<!--          <el-table-column width="100" property="status_2" label="成功"></el-table-column>-->
<!--          <el-table-column width="100" property="status_e" label="错误"></el-table-column>-->
<!--          <el-table-column width="100" property="status_1" label="正在注册"></el-table-column>-->
<!--        </el-table>-->
<!--      </el-popover>-->
    </el-col>
    <el-col style="margin-top: -5px">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="this.pagParams.page"
          :page-sizes="[15,30, 50,100, 200, 500]"
          :page-size="this.pagParams.limit"
          :total="this.pagParams.total"
          layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </el-col>
    <el-table
        class="el-ta"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
        stripe
        border
        size="mini"
        highlight-current-row
        highlight-selection-row
        :default-sort = "{prop: 'sort', order: 'ascending'}">

      <el-table-column
          type="selection"
          width="40px">
      </el-table-column>

      <!--      <el-table-column-->
      <!--          prop="sort"-->
      <!--          label="序号"-->
      <!--          width="80px"-->
      <!--          sortable-->
      <!--          show-overflow-tooltip>-->
      <!--        <template slot-scope="scope">{{ scope.$index+1 }}</template>-->
      <!--      </el-table-column>-->

      <el-table-column
          prop="data"
          label="号码"
          width="110px"
          sortable
          show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
          prop="texing"
          label="特性"
          width="100%"
          sortable
          :filters="[
           { text: '优质用户',value: 1 },
           { text: '劣质用户', value: 2 },
           ]"
          :filter-method="filterStatus"
          filter-placement="bottom-end"
          >

        <template slot-scope="scope">
          <el-tag v-if="scope.row.texing"
              :type=getMsgColor(scope.row.texing)
              disable-transitions>{{getMsg(scope.row.texing)}}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
          prop="lab2"
          label="其他备注"
          width="200px"
      >
      </el-table-column>
      <el-table-column
          prop="use_time"
          label="获取时间"
          width="150px"
          sortable
          show-overflow-tooltip
          :formatter="formatDate"
      >
      </el-table-column>


      <el-table-column
          prop="work"
          label="操作"
          fixed="right"
      >
        <template slot-scope="scope">
          <el-button  size="mini" @click="_showChangDlg(scope.row)">修改</el-button>
<!--          <el-button  icon="el-icon-error" size="mini" @click="delData(scope.row.id)">删除</el-button>-->
        </template>
      </el-table-column>
    </el-table>


    <el-dialog
        :visible.sync="DialogVisible"
        width="80%"
    >
      <el-form ref="form" :model="formAdd" label-width="20px">
        <el-form-item label="号码">
          <el-input type="textarea" :rows="20" v-model="tmp" style="width: 90%;margin-left: 10px;margin-right: 10px;margin-top: -10px"></el-input>
        </el-form-item>
        <el-form-item>
          <!--          <el-button @click="dialogVisible = false">取 消</el-button>-->
          <el-button type="primary" @click="_addData">确 定</el-button>
        </el-form-item>
      </el-form>

    </el-dialog>
    <el-dialog
        :visible.sync="dlgShow_Change"
        width="80%"
        title="修改信息"
    >
      <el-card class="box-card" style="margin-top: -20px">
        <el-form ref="formChange" :model="formChange" label-width="60px" >
          <el-form-item label="备注">
            <el-input v-model="formChange.lab2" style="width: 100%;margin-right: 10px;margin-top: -10px" clearable></el-input>
          </el-form-item>

          <el-form-item label="特性">
            <el-select v-model="formChange.texing" placeholder="请选择">
              <el-option
                  v-for="item in opStatus"
                  :key="item.value"
                  :label="item.label"
                  :value="Number(item.value)">
              </el-option>

            </el-select>
          </el-form-item>
          <el-form-item >
            <el-button type="primary" @click="postChange">确认修改</el-button>
          </el-form-item>

        </el-form>
      </el-card>

    </el-dialog>

  </el-row>

</template>

<script>


import {trim} from "core-js/internals/string-trim";

export default {

  data() {
    return {
      userName : window.sessionStorage.getItem('account'),
      tableData: [],
      multipleSelection: [],
      DialogVisible:false,
      dlgShow_Change:false,
      visibleLab : false,
      pagParams:{
        total:15,limit:15,page:1,searchval:'',downType:0
      },
      formAdd: {
        data:[], status:0,
      },
      formChange:{
        id:null,
        data:null,
        status:null,
        msg:'',
        tmp:null,
        lab2:null,
        texing:null
      },
      labData: [],
      file: null,
      tmp:'',
      loadingLab:true,
      opStatus:[
        { label:"优质用户" , value:1},
        { label:"劣质用户", value:2},
      ],
      copyResult:'',
    }
  },
  created() {
    //this.getData();
  },
  methods: {
    _showChangDlg(row){
      this.formChange.texing = row.texing;
      this.formChange.lab2 = row.lab2;
      this.formChange.id = row.id;
      this.formChange.data = row.data;
      this.dlgShow_Change = true;
    },
    getMsgColor(texing){
      let result = '';
      if(texing === 0){
        result = 'danger';
      }else if(texing === 1){
        result = 'success';
      }else if(texing === 2){
        result = 'danger';
      }else {
        result = 'danger';
      }
      // scope.row.status > 2 ? 'danger' : 'success'";
      return result;
    },
    getMsg(status){
      let result = '';
      if(status === 1){
        result = '优质用户';
      }else if(status === 2){
        result = '劣质用户';
      }
      return result;
    },
    refreshData(downType){
      this.visibleLab = false;
      this.pagParams.page  = 1;
      // this.pagParams.limit = 5;
      // this.pagParams.total = 5;
      this.pagParams.searchval = '';
      this.pagParams.downType = downType;
      this.getData();
    },

    searchData(){
      this.pagParams.page = 1;
      this.getData();
    },
    _addData() {
      if (!this.tmp ){
        this.$msgNot.error('数据不能为空');
        return;
      }

      this.DialogVisible = false;
      this.addData();

    },
    // async getDataOne(){
    //   if (!this.userName) {
    //     this.$msgNot.error('登录状态异常,请重新登录');
    //     return;
    //   }
    //
    //   const loading = this.$loading({
    //     lock: true,
    //     text: '正在获取...',
    //     spinner: 'el-icon-loading',
    //     background: 'rgba(0, 0, 0, 0.7)'
    //   });
    //
    //   const {data:res} = await this.$ajax.post("/api/other/getDataOne",{'account':this.userName});
    //   if (res.code === 200){
    //     this.tableData = res.data;
    //     this.pagParams.total = res.total;
    //     if(res.data.length > 0){
    //       this.copyResult = res.data[0].data;
    //       this.copyData();
    //     }
    //
    //   }else {
    //     this.$msgNot.error('获取数据失败:'+res.msg);
    //   }
    //
    //   loading.close();
    // },
    async getData(){
      if (!this.userName) {
        this.$msgNot.error('登录状态异常,请重新登录');
        return;
      }

      const loading = this.$loading({
        lock: true,
        text: '正在读取...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      const {data:res} = await this.$ajax.post("/api/other/getDataPhoneOne",{'account':this.userName,'data':this.pagParams});
      if (res.code === 200 && res.data){
        this.tableData = res.data;
        this.pagParams.total = res.total;
      }else {
        this.$msgNot.error('获取数据失败:'+res.msg);
      }

      loading.close();
    },
    // async queryData(){
    //   if (!this.userName) {
    //     this.$msgNot.error('登录状态异常,请重新登录');
    //     return;
    //   }
    //   this.visibleLab = !this.visibleLab;
    //   if(!this.visibleLab){
    //     return;
    //   }
    //
    //   const {data:res} = await this.$ajax.post("/api/dmgt/querydata",{'account':this.userName});
    //   if (res.code === 200){
    //     this.labData = res.data;
    //     this.loadingLab = false;
    //   }else {
    //     this.$msgNot.error('查询用量失败:'+res.msg);
    //   }
    //
    // },
    async postChange(){
      if (!this.userName) {
        this.$msgNot.error('登录状态异常,请重新登录');
        return;
      }
      const {data:res} = await this.$ajax.post("/api/other/changeData",{'account':this.userName,'data':this.formChange});
      if (res.code === 200){
        this.$msgNot.success('修改成功');

        this.dlgShow_Change = false;

        //this.pagParams.searchval = res.data.data;
        await this.getData();
      }else {
        this.$msgNot.error('修改失败:'+res.msg);
      }

    },
    async addData(uID = ''){
      if (!this.userName) {
        this.$msgNot.error('登录状态异常,请重新登录');
        return;
      }
      this.formAdd.data = trim(this.tmp).split('\n');
      const {data:res} = await this.$ajax.post("/api/dmgt/addData",{'account':this.userName,'data':this.formAdd,'uid':uID});
      if (res.code === 200){
        this.$msgNot.success('添加成功,数量:'+ this.formAdd.data.length);
        this.formAdd.data = [];
        this.formAdd.status = 0;
        this.tmp = '';
        await this.getData();
      }else {
        this.$msgNot.error('添加数据失败:'+res.msg);
      }

    },
    async delData(id){
      if (!this.userName) {
        this.$msgNot.error('登录状态异常,请重新登录');
        return;
      }

      const {data:res} = await this.$ajax.post("/api/dmgt/deldata",{'account':this.userName,'id':id});
      if (res.code === 200){
        this.$msgNot.success('删除成功');
        await this.getData();
      }else {
        this.$msgNot.error('删除失败:'+res.msg);
      }

    },
    async exPort(){
      if (!this.userName) {
        this.$msgNot.error('登录状态异常,请重新登录');
        return;
      }
      if(this.pagParams.total < 1){
        this.$msgNot.error('暂无数据');
        return;
      }
      await this.$msgBox.confirm('确认导出数据到文件？','提示',{confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning',})
          .then(async ()=>{
            const loading = this.$loading({
              lock: true,
              text: '正在导出...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });

            const {data:res} = await this.$ajax.post("/api/dmgt/exportPhones",{'account':this.userName,'downType':this.pagParams.downType});
            if (res !== ''){

              let pathSave = this.$moment().format('YYYY-MM-DD')+'_数量'+this.pagParams.total+'.txt';
              this.$utils.downloadData(res,pathSave);
              // this.$msgNot.success('导出成功');

            }else {
              this.$msgNot.error('导出失败:'+res.msg);
            }

            loading.close();

          }).catch(()=>{

          });
    },

    async clearData(){
      if (!this.userName) {
        this.$msgNot.error('登录状态异常,请重新登录');
        return;
      }
      let str = '未导出';
      if(this.pagParams.downType === 1){
        str = '已导出';
      }
      await this.$msgBox.confirm('确认清空'+str+'数据？','提示',{confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning',})
          .then(async ()=>{
            const {data:res} = await this.$ajax.post("/api/dmgt/clearData",{'account':this.userName,'downType':this.pagParams.downType});
            if (res.code === 200){
              this.$msgNot.success('清空成功');
              await this.getData();
            }else {
              this.$msgNot.err('清空失败:'+res.msg);
            }

          }).catch(()=>{

          });
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.pagParams.limit = val;
      this.getData();
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.pagParams.page = val;
      this.getData();
    },
    filterStatus(value, row) {
      return row.texing === value;
    },
    filterFeedback(value, row) {
      return row.feedback === value;
    },
    handleChange(file) {
      this.file = file.raw;
    },
    tableRowClassName({row, rowIndex}) {
      return 'warning-row';
    },
    formatDate(row, column) {
      if(!row[column.property]) return '';
      let date = new Date(row[column.property] * 1000)
      const Y = date.getFullYear() + '-'
      const M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-'
      const D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' '
      const h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':'
      const m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':'
      const s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return Y + M + D + h + m + s
    },
    copyData(){
      this.$copyText(this.copyResult).then(() => {
        this.$msgNot.success('已复制到粘贴版');
      }, () => {
        //this.$msgNot.success('复制失败');
      });
    },
  }

}
</script>

<style>

.el-ta {
  /*background-color: #222D32;*/
  color: #000000;
  text-align: left;
  /*line-height: 150px;*/
  padding: 5px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin: 1px 1px 1px -20px;
  width: 100%;

}
.el-table .warning-row {
  background: #f0f9eb;

}


</style>
